import React from "react";
import { PostActionButton } from "./PostCard.styles";
import Images from "config/Images";

const ShareAction: React.FC = () => {
  return (
    <PostActionButton>
      <img src={Images.shareIcon} alt="Share" /> Share
    </PostActionButton>
  );
};

export default ShareAction;
